module.exports = __webpack_public_path__ + "static/media/Step 5-Tokens.ad56f2a1.png";